import React from 'react';

import { Box } from '@mui/system';

import { cn } from 'components/lib/utils';

const AcContentWrapper = ({
  children,
  className,
  customStyle = {}
}: {
  children: React.ReactNode;
  className?: string;
  customStyle?: Record<string, string | number>;
}) => {
  return (
    <Box
      className={cn('content-wrapper', className)}
      px={'3rem'}
      sx={{ ...customStyle }}
    >
      {children}
    </Box>
  );
};

export default AcContentWrapper;
